import { createActionType, createAction } from '@ers/helpers';

const prefix = 'Settings';
export const ActionTypes = {
    exportUserData: createActionType('exportUserData')(prefix),
    exportUserDataCompleted: createActionType('exportUserDataCompleted')(prefix),
    fetchPrivacyConsents: createActionType('fetchPrivacyConsents')(prefix),
    fetchPrivacyConsentsCompleted: createActionType('fetchPrivacyConsentsCompleted')(prefix),
    updatePrivacyConsent: createActionType('updatePrivacyConsent')(prefix),
    deleteUserAccount: createActionType('deleteUserAccount')(prefix),
    fetchActiveSessions: createActionType('fetchActiveSessions')(prefix),
    fetchActiveSessionsCompleted: createActionType('fetchActiveSessionsCompleted')(prefix),
    logoutFromSession: createActionType('logoutFromSession')(prefix),
    logoutFromSessionCompleted: createActionType('logoutFromSessionCompleted')(prefix),
    fetchNotifications: createActionType('fetchNotifications')(prefix),
    fetchNotificationsCompleted: createActionType('fetchNotificationsCompleted')(prefix),
    updateNewApplicationEmailNotification: createActionType('updateNewApplicationEmailNotification')(prefix)
};

export const exportUserData = () => createAction(ActionTypes.exportUserData)({ payload: { } });
export const exportUserDataCompleted = createAction(ActionTypes.exportUserDataCompleted);
export const fetchPrivacyConsents = createAction(ActionTypes.fetchPrivacyConsents);
export const fetchPrivacyConsentsCompleted = createAction(ActionTypes.fetchPrivacyConsentsCompleted);
export const updatePrivacyConsent = (consentId, isChecked) => createAction(ActionTypes.updatePrivacyConsent)({ payload: { consentId, isChecked } });
export const deleteUserAccount = createAction(ActionTypes.deleteUserAccount);
export const fetchActiveSessions = createAction(ActionTypes.fetchActiveSessions);
export const fetchActiveSessionsCompleted = createAction(ActionTypes.fetchActiveSessionsCompleted);
export const logoutFromSession = (sessionId) => createAction(ActionTypes.logoutFromSession)({ payload: { sessionId } });
export const logoutFromSessionCompleted = (sessionId) => createAction(ActionTypes.logoutFromSessionCompleted)({ payload: { sessionId } });
export const fetchNotifications = createAction(ActionTypes.fetchNotifications);
export const fetchNotificationsCompleted = createAction(ActionTypes.fetchNotificationsCompleted);
export const updateNewApplicationEmailNotification = (notificationId, isChecked) => createAction(ActionTypes.updateNewApplicationEmailNotification)({ payload: { notificationId, isChecked } });



